import HeaderSection from "../components/HeaderSection/HeaderSection";

function About() {
  return (
    <>
    <HeaderSection 
      title="About Us" 
      description="We are committed to providing premium VIP mobile numbers to startups and business owners in Sri Lanka. Our mission is to help businesses establish a strong and memorable presence with the right mobile number."
    />
    </>
  );
}

export default About;